import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {
  CreateLandingPageCancellationRequest,
  EnrollmentLandingPageInfoBaseResponseDto,
} from '../models/api-data-contracts';
import {
  applyResolvedEnrollmentPeriods,
  EnrollmentLandingPageInfoWithPeriods,
} from '../common/enrollment-period.resolver';
import { BaseService } from './base.service';
import { TurnstileTokenService } from './turnstile-token.service';

@Injectable({
  providedIn: 'root'
})
export class LandingPagesService extends BaseService {

  constructor(
    private http: HttpClient,
    protected override turnstileTokenService: TurnstileTokenService
  ) {
    super(turnstileTokenService);
  }

  url = `${environment.ApiURL}/landing-page`;

  getLandingPageInfo(id: string) : Observable<EnrollmentLandingPageInfoBaseResponseDto>{
    return this.http.get<EnrollmentLandingPageInfoBaseResponseDto>(`${this.url}/${id}`).pipe(
      map((response) => {
        if (response?.data) {
          applyResolvedEnrollmentPeriods(response.data as EnrollmentLandingPageInfoWithPeriods);
        }
        return response;
      })
    );
  }

  createCancellationRequest(
    landingPageId: string,
    body: CreateLandingPageCancellationRequest
  ): Observable<string> {
    const headers = this.getHeaders('', true);
    return this.http.post(`${this.url}/${landingPageId}/cancellation-requests`, body, {
      headers,
      responseType: 'text',
    });
  }
}
